import {EditContentChangeRequest} from './edit-content-change-request';

export default EditContentChangeRequest;